module.exports = window.styledComponents;